import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Text from '../Text';
import { COLOR } from '../../Theme';

const getHoverColor = (isDisabled, hoverColor, disabledColor) => {
  return isDisabled ? disabledColor : hoverColor;
};

const LinkView = styled(({ disabled, disabledColor, underline, hoverColor, ...restProps }) => (
  <Text {...restProps} />
))`
  color: ${props => (props.disabled ? props.disabledColor || COLOR.greyscale.grey3 : props.color)};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};

  &:hover {
    text-decoration: underline;
    color: ${props =>
      getHoverColor(
        props.disabled,
        props.hoverColor || COLOR.primary,
        props.disabledColor || COLOR.greyscale.grey3,
      )};
  }

  ${props =>
    props.underline &&
    css`
      text-decoration: underline;
    `}
`;
class Link extends Component {
  static propTypes = {
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };
  handleClick = data => {
    if (!this.props.disabled) this.props.onClick(data);
  };
  render() {
    return <LinkView {...this.props} onClick={this.handleClick} />;
  }
}

export default Link;
